import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { IncidentTypeService } from 'cbd-proxies';
import { RotationProjectionPlanningOrchestratorService } from 'orchestrator';
import { IncidentService } from '../proxy/operational/controllers';

FieldBuilder.setNamespace('Operational');

export const INCIDENTPERSTAND_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('area', 'Entity.IncidentPerStand.Area')
    .required()
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'incidentId',
    'Entity.Incident',
    IncidentService
  )
    .required()
    .displayFromNested('incident.name')
    .sortBy('incident.name')
    .build(),
  FieldBuilder.foreignKey(
    'incidentTypeId',
    'Entity.IncidentType',
    IncidentTypeService
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'rotationId',
    'Entity.Rotation',
    RotationProjectionPlanningOrchestratorService
  )
    .required()
    .display('rotationDisplay')
    .displayFromNested('rotation.name')
    .sortBy('rotation.name')
    .build(),
];

export const INCIDENTPERSTAND_CONFIG = {
  entityName: 'IncidentPerStand',
  localizationKey: 'Operational::Entity.IncidentPerStand',
  fields: INCIDENTPERSTAND_FIELDS,
  permission: 'PlanningOperation.IncidentPerStands',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
